import { jsx } from "react/jsx-runtime";
import { PersonnelFilled } from "@wepie/weet-icons";
import AvatarContainer from "./AvatarContainer.js";
import { rootClass } from "../constant.js";
import classnames from "classnames";
const EmptyAvatar = (props)=>/*#__PURE__*/ jsx(AvatarContainer, {
        ...props,
        className: classnames(props.className, `${rootClass}__empty`),
        children: /*#__PURE__*/ jsx("span", {
            className: "weet-avatar-icon",
            children: props?.icon ? props.icon : /*#__PURE__*/ jsx(PersonnelFilled, {})
        })
    });
const components_EmptyAvatar = EmptyAvatar;
export { components_EmptyAvatar as default };
